import { InvoiceDetail } from "./invoice-detail";
import { InvoiceReceipt } from "./invoice-receipt";
import { PersonAccount } from "./person-account";
import { Shipment } from "./shipment";
import { SystemField } from "./system-field";

export class Invoice extends SystemField { 
     bill_to_id?:string;
     invoice_num?:string;
     status?:string;
     amount_paid?:number;
     inv_date?:string;
     record_type_id?:string;
     grand_total?:number;
     penalty_amount?:number;
     inv_type?: string;
     sub_total?:number;
     discount_total?:number;
     discount_rate?:number;
     tax_total?:number;
     customer_coa_id?:string;
     source?:string;
     
     //formula fields
     due_balance?: number;
     details_count?: number;
     shipments_count?:number;

     // relationship
     langs?:any;
     details?: InvoiceDetail[];
     bill_to?: PersonAccount;
     invoice_receipts?:InvoiceReceipt[];
     shipments?:Shipment[];
}
export class InvoiceTranslation extends SystemField{ 
     lang_code?:string;
     comments?:string;
     note?:string;
     invoices_id?:string;
}